module.exports = __webpack_public_path__ + "media/images/rocket_boost_img-0bf8a6af9571f866e61d0784416715f5.svg";